import type { ActionConfig } from './types';

export const employeeActions: ActionConfig[] = [
  // =============================================================================
  // COMMUNICATION ACTIONS
  // =============================================================================
  {
    id: 'emp-call-phone',
    name: 'Call Phone (Cell)',
    icon: 'phone',
    table: 'employees',
    type: 'CALL',
    prominence: 'inline',
    order: 1,
    condition: (row) => Boolean(row.cell),
    config: {
      phoneColumn: 'cell',
    },
  },
  {
    id: 'emp-send-sms',
    name: 'Send SMS (Cell)',
    icon: 'comment',
    table: 'employees',
    type: 'SMS',
    prominence: 'inline',
    order: 2,
    condition: (row) => Boolean(row.cell),
    config: {
      phoneColumn: 'cell',
    },
  },
  {
    id: 'emp-compose-email',
    name: 'Compose Email',
    icon: 'envelope',
    table: 'employees',
    type: 'EMAIL',
    prominence: 'inline',
    order: 3,
    condition: (row) => Boolean(row.email),
    config: {
      to: (row) => String(row.email || ''),
    },
  },

  // =============================================================================
  // RECORD ACTIONS
  // =============================================================================
  {
    id: 'emp-edit',
    name: 'Edit',
    icon: 'edit',
    table: 'employees',
    type: 'EDIT_RECORD',
    prominence: 'prominent',
    order: 10,
    condition: (row, user) =>
      user.viewTags.includes('Management Views') || row.email === user.email,
    config: {},
  },
  {
    id: 'emp-add',
    name: 'Add',
    icon: 'plus',
    table: 'employees',
    type: 'ADD_RECORD',
    prominence: 'prominent',
    order: 11,
    requiredViews: ['Management Views'],
    config: {},
  },
  {
    id: 'emp-delete',
    name: 'Delete',
    icon: 'trash',
    table: 'employees',
    type: 'DELETE_RECORD',
    prominence: 'menu',
    order: 99,
    requiredViews: ['Management Views'],
    needsConfirmation: true,
    confirmationMessage: 'Are you sure you want to delete this employee?',
    config: {},
  },

  // =============================================================================
  // NAVIGATION ACTIONS
  // =============================================================================
  {
    id: 'emp-view-schedule',
    name: 'View Schedule',
    icon: 'calendar',
    table: 'employees',
    type: 'NAVIGATE_APP',
    prominence: 'prominent',
    order: 21,
    config: {
      route: '/schedules',
      params: { employee: 'key' },
    },
  },
  {
    id: 'emp-view-service-logs',
    name: 'View Service Logs',
    icon: 'list',
    table: 'employees',
    type: 'NAVIGATE_APP',
    prominence: 'prominent',
    order: 22,
    config: {
      // Route with query string - employee ID for filtering
      route: (row: Record<string, unknown>) => `/service-logs?employee=${encodeURIComponent(String(row.id || ''))}`,
    },
  },

  // =============================================================================
  // EXPORT ACTIONS
  // =============================================================================
  {
    id: 'emp-download',
    name: 'Download',
    icon: 'download',
    table: 'employees',
    type: 'EXPORT_VIEW',
    prominence: 'menu',
    order: 50,
    config: {},
  },
];
